<template>
  <font-awesome-icon
    icon="times-circle"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faTimesCircle)

export default {
  name: 'CoozzyFailIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-red;
  }
</style>
